// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"EditPopup_deleteButton__Ktz-D","field":"EditPopup_field__3dv82","text":"EditPopup_text__3C_dA"};